import { fetchHandler, fetchRequestBuilder, HTTP_METHOD, limiter } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const getAccountPublicInfo = (accountId) => {

    const request = fetchRequestBuilder(`account/${accountId}/publicinfo`, HTTP_METHOD.GET, {}, true, false, true)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}